import React from 'react';
import { ColumnButton, ColumnHelpers } from '@westernmilling/eu_react_shared';

const Columns = (context) => [
  {
    Header: 'Reference',
    accessor: 'related_entity_reference',
    className: 'text-center',
    width: 150,
  },
  {
    Header: 'Name',
    accessor: 'related_entity_name',
    className: 'text-left',
  },
  ColumnHelpers.activeInactiveColumn(150),
  ColumnHelpers.auditLogLink(context, 150),
  ColumnHelpers.columnEditButton(context, 150),
];

export default Columns;
